import { Either, HomeFailure, left, right } from "../../domain";
import {
  HomeContent,
  HomeRepository,
} from "../../domain/repositories/home-repository";
import { HomeRemoteDataSourceError } from "../core";
import { HomeRemoteDataSource } from "../data-sources";

export class HomeRepositoryImpl implements HomeRepository {
  constructor(private readonly remoteDataSource: HomeRemoteDataSource) {}

  private handleError(error: HomeRemoteDataSourceError): HomeFailure {
    if (error === "NetworkError") return HomeFailure.networkFailure();
    return HomeFailure.serverFailure();
  }

  public async getHomeContent(): Promise<Either<HomeFailure, HomeContent>> {
    try {
      const res = await this.remoteDataSource.getHomeContent();
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }
}
